export default __webpack_public_path__ + "static/certificate-pr-square-c8385350429f5a9100a52af79fb7e7ba.jpg";